import React, { useEffect, useState } from 'react';
import { useItems } from '../contexts/ItemsContext';
import './MiniCart.css';

const DEFAULT_IMG = '/logo192.png'; // אפשר לשנות לתמונה מתאימה

const MiniCart = ({ isOpen, items, onClose, onGoToCart }) => {
  const [visible, setVisible] = useState(isOpen);
  const [closing, setClosing] = useState(false);
  const [fullItems, setFullItems] = useState([]);
  const { getItemById } = useItems();

  useEffect(() => {
    // טען מידע מלא לכל מוצר
    const enrichItems = async () => {
      if (items && items.length > 0) {
        const enriched = await Promise.all(
          items.map(async (item) => {
            if (item.files && Array.isArray(item.files) && item.files.length > 0) return item;
            const full = await getItemById(item.id);
            return full || item;
          })
        );
        setFullItems(enriched);
      } else {
        setFullItems([]);
      }
    };
    enrichItems();
  }, [items, getItemById]);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setClosing(false);
    } else if (visible) {
      setClosing(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setClosing(false);
      }, 400); // זמן האנימציה
      return () => clearTimeout(timer);
    }
  }, [isOpen, visible]);

  if (!visible) return null;

  return (
    <div className="mini-cart-overlay" onClick={onClose}>
      <div className={`mini-cart${closing ? ' mini-cart--closing' : ''}`} onClick={e => e.stopPropagation()}>
        <div className="mini-cart-header">
          <h3>סל הקניות שלי</h3>
          <button className="mini-cart-close" onClick={onClose}>X</button>
        </div>
        <div className="mini-cart-items">
          {fullItems.length === 0 ? (
            <div className="mini-cart-empty">הסל ריק</div>
          ) : (
            fullItems.map(item => {
              const img = item.files?.find(f => f.type === 'image')?.url || item.url || DEFAULT_IMG;
              const displayPrice = item.sale_price !== null && item.sale_price !== undefined ? item.sale_price : item.price;
              return (
                <div className="mini-cart-item" key={item.id}>
                  <img src={img} alt={item.name} className="mini-cart-item-img" />
                  <div className="mini-cart-item-info">
                    <span className="mini-cart-item-name">{item.name}</span>
                    <span className="mini-cart-item-price">₪{displayPrice}</span>
                  </div>
                </div>
              );
            })
          )}
        </div>
        <div className="mini-cart-actions">
          <button className="mini-cart-btn" onClick={onGoToCart}>לסל קניות</button>
          <button className="mini-cart-btn primary" onClick={onGoToCart}>סיום הזמנה</button>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;
